import React from 'react';
import { DefaultTheme } from 'styled-components';

interface Props {
  theme?: DefaultTheme;
}

const IllustrationAdvisoryConvo: React.FC<React.PropsWithChildren<Props>> = ({
  theme,
  ...otherProps
}) => {
  return (
    <svg
      width="304"
      height="304"
      fill="none"
      viewBox="0 0 304 304"
      xmlns="http://www.w3.org/2000/svg"
      {...otherProps}
    >
      <path stroke="#C0C2C9" d="M10 297.5h290" />
      <path
        d="m284.677 55.622-1.793-2.916c-14.872-24.203-41.926-38.565-70.256-36.392a74.279 74.279 0 0 0-9.637 1.378c-25.45 5.38-47.598 24.385-56.776 48.727-5.395 14.31-6.904 30.794-17.147 42.159-13.334 14.785-35.97 15.251-55.872 14.639-19.902-.612-42.553-.095-55.82 14.755-8.312 9.295-10.936 22.52-10.28 34.993 1.772 32.959 25.035 62.419 54.618 77.072 29.584 14.653 64.416 15.958 96.799 9.514 45.36-9.026 88.496-33.819 114.456-72.122 25.961-38.303 32.463-90.471 11.708-131.807Z"
        fill="#F0F1F3"
      />
      <path
        d="M101.345 93.567c16.857-16.857 16.857-44.187 0-61.045-16.857-16.857-44.187-16.857-61.044 0-16.857 16.858-16.857 44.188 0 61.045s44.187 16.857 61.044 0Z"
        fill="#F0F1F3"
      />
      <path
        d="M279.566 259.104c.519-1.784 1.621-3.498 3.335-4.25 1.715-.753 3.837-.333 5.657.332 1.819.665 3.609 1.545 5.539 1.662 1.93.116 4.117-.793 4.694-2.642.542-1.749-.507-3.592-1.813-4.857a11.464 11.464 0 0 0-18.771 4.507"
        fill={theme ? theme.secondary[700] : '#6E7382'}
      />
      <path
        d="M264.254 266.86c-2.834-2.694-2.694-7.382-1.277-11.033 1.417-3.65 4.501-6.443 7.947-8.292a25.19 25.19 0 0 1 21.943-.705 10.41 10.41 0 0 0-8.42 4.939c-1.551 2.583-1.901 5.714-3.184 8.443a13.28 13.28 0 0 1-17.009 6.648Z"
        fill={theme ? theme.secondary[600] : '#888D9B'}
      />
      <path
        d="M261.385 281.093a1.888 1.888 0 0 1 0-.425v-1.225c.035-1.067.134-2.606.373-4.49a58.254 58.254 0 0 1 1.201-6.577 30.35 30.35 0 0 1 2.997-7.616 31.61 31.61 0 0 1 4.91-6.554 30.824 30.824 0 0 1 5.143-4.274c.782-.542 1.545-.95 2.198-1.335.654-.385 1.254-.636 1.75-.863l1.131-.473c.129-.061.264-.11.402-.145a2.019 2.019 0 0 1-.373.198l-1.108.525c-.466.245-1.043.548-1.702.909a21.77 21.77 0 0 0-2.164 1.365 31.727 31.727 0 0 0-5.061 4.286 32.215 32.215 0 0 0-4.84 6.507c-2.916 5.05-3.679 10.35-4.257 14.071a62.487 62.487 0 0 0-.466 4.472c-.035.502-.058.91-.076 1.219a1.908 1.908 0 0 1-.058.425Zm-27.08-45.027c-5.831 3.498-5.79 6.694-4.816 9.708.973 3.015 4.53 5.103 7.487 3.977 1.673-.641 2.88-2.093 3.918-3.551 1.038-1.458 2-3.02 3.452-4.082 1.452-1.061 3.546-1.446 5.003-.408"
        fill={theme ? theme.secondary[700] : '#6E7382'}
      />
      <path
        d="M229.961 239.908c1.516-2.099 5.248-2.705 7.639-1.656 2.391 1.05 4.082 3.126 5.656 5.196 1.574 2.07 3.067 4.262 5.219 5.703 2.152 1.44 5.155 1.965 7.3.513a6.255 6.255 0 0 0 2.479-4.298c.19-1.694.076-3.408-.339-5.061-.513-2.438-1.352-4.98-3.3-6.531-2.169-1.72-5.184-1.802-7.959-1.714-3.184.105-6.415.344-9.394 1.446-2.98 1.102-6.036 3.498-7.301 6.414"
        fill={theme ? theme.secondary[600] : '#888D9B'}
      />
      <path
        d="M256.557 276.44a3.116 3.116 0 0 1-.041-.501l-.053-1.441c-.035-1.282-.093-3.084-.157-5.3a324.989 324.989 0 0 0-.327-7.86c-.157-2.957-.39-6.205-.839-9.581a30.615 30.615 0 0 0-.957-4.863 25.252 25.252 0 0 0-1.778-4.257 22.992 22.992 0 0 0-4.694-6.216 17.914 17.914 0 0 0-4.339-2.968 13.442 13.442 0 0 0-1.317-.583 2.404 2.404 0 0 1-.461-.204c.162.039.322.087.478.146.463.143.915.318 1.353.525a17.192 17.192 0 0 1 4.432 2.915 22.808 22.808 0 0 1 4.793 6.239 24.836 24.836 0 0 1 1.813 4.298 30.15 30.15 0 0 1 .98 4.916c.449 3.393.665 6.647.816 9.609.152 2.962.216 5.621.263 7.866.046 2.245.058 4.053.058 5.301v1.446c.007.171-.001.343-.023.513Z"
        fill={theme ? theme.secondary[700] : '#6E7382'}
      />
      <path
        d="M262.895 250.684c-3.143-3.703-3.563-9.65-3.097-14.484.467-4.834 1.581-9.703.817-14.502-.449-2.84-1.551-5.551-1.924-8.409-.374-2.857.157-6.076 2.367-7.918 2.542-2.117 6.543-1.616 9.184.367 2.642 1.983 4.175 5.114 5.295 8.222 2.443 6.834 3.358 14.414 1.341 21.412-2.018 6.997-6.758 13.219-13.715 15.324"
        fill={theme ? theme.secondary[600] : '#888D9B'}
      />
      <path
        d="M258.65 279.064a15.96 15.96 0 0 1-.648-2.49 26.289 26.289 0 0 1-.274-6.997 46.433 46.433 0 0 1 2.21-10.169c1.196-3.738 2.811-7.738 4.193-12.03a55.607 55.607 0 0 0 1.668-6.362c.382-2.007.656-4.033.822-6.07.266-3.455.33-6.923.192-10.385-.099-2.957-.25-5.347-.35-6.998-.046-.804-.081-1.446-.105-1.9v-.496a.48.48 0 0 1 0-.169c.003.054.003.109 0 .163 0 .128.03.292.053.496.041.455.093 1.09.163 1.901.134 1.65.321 4.041.449 6.997a85.951 85.951 0 0 1-.128 10.414 56.497 56.497 0 0 1-.811 6.106 54.575 54.575 0 0 1-1.667 6.414c-1.388 4.309-3.015 8.297-4.216 12.024a47.274 47.274 0 0 0-2.263 10.105 27.186 27.186 0 0 0 .175 6.968c.14.816.268 1.446.385 1.866.047.198.082.356.117.484a.691.691 0 0 1 .035.128Z"
        fill={theme ? theme.secondary[700] : '#6E7382'}
      />
      <path
        d="M273.047 281.688h-27.272l-.624-5.248h27.896v5.248Z"
        fill={theme ? theme.secondary[700] : '#6E7382'}
      />
      <path
        d="m248.702 281.094 3.411 15.749h14.817l3.19-15.749h-21.418Z"
        fill={theme ? theme.secondary[700] : '#6E7382'}
      />
      <path
        d="M273.047 281.688c0 .088-5.995.14-13.412.117-7.417-.024-13.411-.105-13.411-.193 0-.087 5.994-.134 13.411-.11 7.417.023 13.412.105 13.412.186Z"
        fill={theme ? theme.secondary[600] : '#888D9B'}
      />
      <path
        d="M42.064 277.853a12.038 12.038 0 0 0-7.446-.907 6.187 6.187 0 0 0-3.682 1.642c-.913 1.017-1.092 2.803 0 3.675a3.51 3.51 0 0 0 2.315.584c1.971 0 4.156-.364 5.729.817.893.687 1.49 1.8 2.569 2.13a2.54 2.54 0 0 0 2.788-1.237 4.335 4.335 0 0 0 .316-3.201 4.886 4.886 0 0 0-2.59-3.503Z"
        fill={theme ? theme.primary[500] : '#C0C2C9'}
      />
      <path
        d="M47.346 297.67a3.945 3.945 0 0 1-.124-.893l-.24-2.459a33.645 33.645 0 0 0-.55-3.593 27.829 27.829 0 0 0-1.312-4.251 15.586 15.586 0 0 0-2.163-3.84 8.173 8.173 0 0 0-2.748-2.281 7.608 7.608 0 0 0-2.308-.687c-.3-.016-.6-.06-.893-.13.304-.037.61-.037.914 0 .833.06 1.647.272 2.404.625a8.04 8.04 0 0 1 2.892 2.301 15.106 15.106 0 0 1 2.246 3.915c.56 1.399.994 2.845 1.298 4.321.235 1.202.395 2.418.481 3.64.076 1.045.11 1.883.124 2.466.025.289.018.579-.021.866Z"
        fill={theme ? '#222' : '#6E7382'}
      />
      <path
        d="M47.23 267.838c-1.375 1.978-4.074 1.319-5.324.11-1.25-1.209-1.772-2.954-2.253-4.623-1.1-3.812-2.205-7.81-1.374-11.677a6.42 6.42 0 0 1 1.497-3.208 3.386 3.386 0 0 1 3.215-1.071c1.374.357 2.205 1.683 2.816 2.947a27.98 27.98 0 0 1 2.748 11.965c0 1.93-.22 3.95-1.312 5.543"
        fill={theme ? theme.primary[500] : '#C0C2C9'}
      />
      <path
        d="M47.174 295.788a1.65 1.65 0 0 1 0-.419v-1.195c0-1.031 0-2.528-.048-4.383-.096-3.695-.412-8.806-1.03-14.424-.618-5.619-1.443-10.661-2.191-14.288a51.39 51.39 0 0 0-.522-2.438c-.172-.715-.296-1.34-.426-1.834-.13-.495-.206-.859-.282-1.161a1.858 1.858 0 0 1-.069-.412c.066.123.114.255.145.391l.343 1.141c.158.494.316 1.112.495 1.827.178.714.384 1.525.577 2.431a134.424 134.424 0 0 1 2.3 14.301c.619 5.626.894 10.75.921 14.459 0 1.855 0 3.352-.069 4.39 0 .48-.054.879-.068 1.188a1.582 1.582 0 0 1-.076.426Z"
        fill={theme ? '#222' : '#6E7382'}
      />
      <path
        d="M51.055 270.675a7.185 7.185 0 0 1-1.12-6.622 12.711 12.711 0 0 1 3.923-5.694 21.056 21.056 0 0 1 7.027-4.121 7.473 7.473 0 0 1 3.16-.536 3.294 3.294 0 0 1 2.65 1.6c.736 1.409 0 3.119-.741 4.513a52.853 52.853 0 0 1-4.61 7.027c-1.373 1.786-2.967 3.545-5.075 4.348-2.109.804-4.3.687-5.413-.748"
        fill={theme ? theme.primary[500] : '#C0C2C9'}
      />
      <path
        d="M47.154 285.91a7.904 7.904 0 0 1 0-1.25 35.03 35.03 0 0 1 .385-3.372 46.033 46.033 0 0 1 3.152-10.737 30.874 30.874 0 0 1 6.038-9.403c.445-.47.92-.91 1.422-1.319.213-.185.405-.371.605-.515l.55-.378c.33-.258.681-.488 1.05-.687a38.484 38.484 0 0 0-3.434 3.064 32.973 32.973 0 0 0-5.887 9.369 46.862 46.862 0 0 0-2.06 5.77c-.537 1.806-.894 3.469-1.169 4.87a39.627 39.627 0 0 0-.494 3.338c-.025.42-.078.838-.158 1.25Z"
        fill={theme ? '#222' : '#6E7382'}
      />
      <g filter="url(#a)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M242.486 74H114.62a8.79 8.79 0 0 0-8.79 8.797v68.974a8.789 8.789 0 0 0 8.79 8.79h82.808l31.273 27.769 2.613-27.769h11.172a8.793 8.793 0 0 0 8.797-8.796V82.797A8.796 8.796 0 0 0 242.486 74Z"
          fill="#fff"
        />
      </g>
      <path
        d="M146.951 126.813a8.469 8.469 0 1 0-.001-16.937 8.469 8.469 0 0 0 .001 16.937Zm29.147 0a8.469 8.469 0 1 0-.001-16.937 8.469 8.469 0 0 0 .001 16.937Zm29.147 0a8.47 8.47 0 1 0 0-16.939 8.47 8.47 0 0 0 0 16.939Z"
        fill={theme ? theme.primary[500] : '#C0C2C9'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M188.656 116.67H60.79a8.794 8.794 0 0 0-8.79 8.797v68.974a8.79 8.79 0 0 0 8.79 8.791h82.808L174.871 231l2.613-27.768h11.172a8.794 8.794 0 0 0 8.797-8.797v-68.968a8.794 8.794 0 0 0-8.797-8.797Z"
        fill={theme ? theme.primary[500] : '#C0C2C9'}
      />
      <path
        d="M97.336 169.64a8.469 8.469 0 1 0 0-16.937 8.469 8.469 0 0 0 0 16.937Zm29.146 0a8.469 8.469 0 1 0 0-16.937 8.469 8.469 0 0 0 0 16.937Zm29.147 0a8.469 8.469 0 1 0 0-16.937 8.469 8.469 0 0 0 0 16.937Z"
        fill="#fff"
      />
      <defs>
        <filter
          id="a"
          x={103.83}
          y={72.5}
          width={149.453}
          height={118.33}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={0.5} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0.376471 0 0 0 0 0.380392 0 0 0 0 0.439216 0 0 0 0.16 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_353_902"
          />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation={0.5} />
          <feColorMatrix values="0 0 0 0 0.156863 0 0 0 0 0.160784 0 0 0 0 0.239216 0 0 0 0.08 0" />
          <feBlend
            in2="effect1_dropShadow_353_902"
            result="effect2_dropShadow_353_902"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_353_902"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default IllustrationAdvisoryConvo;
